import type { MaterialOrderRequestColumn } from '../../types/column-types'
import { requestNumberColumn } from './request-number'
import { createdAtColumn } from './created-at'
import { requestStatusColumn } from './request-status'
import { clientColumn } from './client'
import { amountColumn } from './amount'
import { materialColumns } from './material-columns'
import { arrivalDateColumn } from './arrival-date'

export const columns: MaterialOrderRequestColumn[] = [
    requestNumberColumn,
    createdAtColumn,
    requestStatusColumn,
    clientColumn,
    amountColumn,
    ...materialColumns,
    arrivalDateColumn,
]
